module.exports = __webpack_public_path__ + "img/xlwlogo.de10952c.png";